import * as React from 'react';
import { graphql } from 'gatsby';
import { PrismicRichText } from '@prismicio/react';
// import { Parallax } from 'react-scroll-parallax';
// @ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

type ProjectCreditsListProps = {
    slice: any;
};

export const ProjectCreditsList: React.FC<ProjectCreditsListProps> = ({ slice }) => {
    const breakpoints = useBreakpoint();

    return (
        <div className={`sliceProjectCreditsList container ${breakpoints.sm ? 'mobile' : ''}`}>
            {slice.primary.credits_section_title.text && (
                <p className="sliceTitle">{slice.primary.credits_section_title.text}</p>
            )}
            <div className="creditWrapper">
                <div className={`creditItems ${breakpoints.sm ? 'mobile' : ''}`}>
                    {slice.items.map((item: any, index: number) => (
                        <div className="creditItem" key={'item_' + index}>
                            <div className="category">
                                <PrismicRichText field={item.credit_title.richText} />
                            </div>
                            <p className="separator">:</p>
                            <div className="names">
                                <PrismicRichText field={item.credit_name.richText} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export const query = graphql`
    fragment ProjectDataCreditsList on PrismicProjectDataBodyCreditsList {
        primary {
            credits_section_title {
                text
            }
        }
        items {
            credit_title {
                richText
            }
            credit_name {
                richText
            }
        }
    }
`;
